
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import AnimateInView from '@/components/ui/animate-in-view';
import GoldSectionDivider from '@/components/ui/gold-section-divider';

export interface IndustryProps {
  id: number;
  name: string;
  icon: string;
  description: string;
}

interface IndustriesSectionProps {
  industries: IndustryProps[];
}

const IndustriesSection: React.FC<IndustriesSectionProps> = ({ industries }) => {
  return (
    <section className="py-16 md:py-24 bg-boundri-background" aria-labelledby="industries-heading">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center mb-12">
      <GoldSectionDivider centered />
          <h2 id="industries-heading" className="text-center text-boundri mb-2">Industries We Serve</h2>
          <p className="text-center text-boundri-charcoal max-w-2xl">
            From sprawling estates to critical infrastructure, our solutions adapt to the unique needs of each industry.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {industries.map((industry) => (
            <AnimateInView 
              key={industry.id} 
              animation="scale-in" 
              delay={100 * industry.id}
              className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 border border-boundri-lavender/20"
            >
              <div className="text-4xl mb-4">{industry.icon}</div>
              <h3 className="text-xl font-serif mb-3">{industry.name}</h3>
              <p className="text-boundri-charcoal">{industry.description}</p>
            </AnimateInView>
          ))}
        </div>

        <div className="text-center">
          <Button asChild size="xl" variant="gradient" className="text-white">
            <Link to="/industries">
              See All Industries
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
